// extracted by mini-css-extract-plugin
export default {"container":"sidebarlink_container__V1LiB","activeLink":"sidebarlink_activeLink__9RRuH"};